import { PayloadAction, createSlice } from '@reduxjs/toolkit';
import { OrderByType } from 'config/constants/search.constants';
import { Search } from '../models/search.model';

const initialState: Search = {
  searchTerm: '',
  isFetching: false,
  page: 1,
  orderBy: OrderByType.DESC,
  price: '',
  filteredBrands: '',
};

const searchSlice = createSlice({
  name: 'search',
  initialState,
  reducers: {
    fetchingRefresh: (state, action: PayloadAction<boolean>) => {
      state.isFetching = action.payload;
      return state;
    },
    refreshSearchStore: (state: Search, action: PayloadAction<Search>) => {
      state = { ...state, ...action.payload };
      return state;
    },
    resetSearchStore: () => initialState,
  },
});

export const SearchSlice = searchSlice.actions;
export default searchSlice.reducer;
